import React, { FC } from 'react';
import './FileField.css';
import { useFormikContext } from 'formik';
import { ErrorMessage } from '@/Shared/Lib/Logic';
import { FaFile } from 'react-icons/fa';
import { UPLOAD_ALLOWED_DOC_FILE_EXTENTIONS } from '@/Shared/Types';

interface FileFieldProps {
	label: string,
	name: string,
	placeholder?: string,
	autoComplete?: string,
	multiple?: boolean,
	required?: boolean,
	readOnly?: boolean,
}

const FileField: FC<FileFieldProps> = ({
	label,
	name,
	placeholder,
	autoComplete,
	multiple = false,
	required = false,
	readOnly = false
}) => {

	const { setFieldValue  } = useFormikContext();

	return (
		<label className={`InputField data-field-label ${readOnly ? 'readonly' : ''}`}
			data-testid="InputField"
			title={readOnly ? 'Champ non modifiable' : 'Champ modifiable'}>
			{label && (<div>{label} {required && <span className="asterisk" aria-hidden="true"> *</span>}</div>)}
			<div className="form-group">
				<div className='Field-wrapper'>
					<div className='file-placeholder'><FaFile /> {placeholder || label}</div>
					
					<input
						hidden
						multiple={multiple}
						name={name}
						type='file'
						className="input-field"
						autoComplete={autoComplete || 'off'}
						accept={UPLOAD_ALLOWED_DOC_FILE_EXTENTIONS.join(',')}
						onChange={(e) => {
							const file = multiple ? [...e.target.files!] : e.target.files![0];
							setFieldValue(name, file, true);
						}}
					/></div>

				<ErrorMessage name={name} component="div" className="error-message" />
			</div>
		</label>
	);
}

export default FileField;
